import React from 'react';
import PropTypes from 'prop-types';

const KeyValueTable = ({
  caption,
  headingId,
  data,
  dataTestId,
  className = '',
}) => (
  <table
    aria-labelledby={caption ? undefined : headingId}
    className={`key-value-table ${className}`}
    data-testid={dataTestId}
  >
    {caption && (
      <caption className="key-value-table__heading">{caption}</caption>
    )}
    <tbody>
      {Object.entries(data).map(([key, value]) => (
        <tr className="key-value-table__row" key={key}>
          <th className="key-value-table__key" scope="row">
            {key}
          </th>
          <td className="key-value-table__value">{value ?? 'Not available'}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

KeyValueTable.propTypes = {
  data: PropTypes.objectOf(PropTypes.node).isRequired,
  dataTestId: PropTypes.string,
  headingId: PropTypes.string,
  caption: PropTypes.string,
  className: PropTypes.string,
};

export default KeyValueTable;
